<script setup lang="ts">
withDefaults(defineProps<{ size?: 's' | 'm'; loading?: boolean }>(), { size: 'm' });

const store = useStopsFilterStore();
const switchId = useId();
</script>

<template>
  <div
    v-if="loading"
    class="flex flex-col gap-4"
  >
    <div
      v-for="i in 2"
      :key="i"
      class="flex flex-col gap-2"
    >
      <UiSkeleton class="h-2 w-32 rounded-full" />
      <UiSkeleton class="h-4 w-full rounded-full" />
      <div class="flex justify-between">
        <UiSkeleton class="h-2 w-12" />
        <UiSkeleton
          v-if="i === 1"
          class="h-2 w-12"
        />
        <UiSkeleton class="h-2 w-12" />
      </div>
    </div>
    <div class="flex h-9 items-center gap-2">
      <UiSkeleton class="h-5 w-9 min-w-9 rounded-full" />
      <div class="flex w-full flex-col gap-1">
        <UiSkeleton class="h-2 w-4/5" />
        <UiSkeleton class="h-2 w-full" />
      </div>
    </div>
  </div>

  <template v-else>
    <UiCustomFilterLabeledSlider
      v-model="store.stopsValue"
      :size="size"
      :min="0"
      :max="2"
      :step="1"
      :title="$t('components.results.filters.stopsCountTitle')"
    >
      <template #labels>
        <span>{{ $t('components.results.filters.stopsDirect') }}</span>
        <span>{{ $t('components.results.filters.stopsOneStop') }}</span>
        <span>{{ $t('components.results.filters.stopsTwoPlus') }}</span>
      </template>
    </UiCustomFilterLabeledSlider>
    <UiCustomFilterLabeledSlider
      v-model="store.stopDurationValue"
      :size="size"
      :min="0"
      :max="24"
      :step="1"
      :title="$t('components.results.filters.stopsDurationTitle')"
      :disabled="store.stopsValue === 0"
    >
      <template #labels="{ start, end }">
        <span>{{ start }}h</span>
        <span>{{ end }}h</span>
      </template>
    </UiCustomFilterLabeledSlider>
    <UiCustomFilterLabeledSwitch
      :id="switchId"
      v-model="store.allowAirportChange"
      :size="size"
      :label="$t('components.results.filters.stopsAllowAirportChange')"
      :disabled="store.stopsValue === 0"
    />
  </template>
</template>
